import { Helmet } from "react-helmet";
import BreadCrumb from "../../component/BreadCrumb";

import AxiosClient from "../../client/AxiosClient";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_GET_SINGLE_BLOG } from "./../../ApiEndPoints";
import NativeLazyImage from "./../../component/NativeLazyImage";
import Loader from "../../component/Loader";
import RawHTML from "../../component/RawHTML";
import "./../../pages/styles/ckeditor5-content.css";

export default function SingleBlogPage() {
  // getting recent blogs with pagination starts
  const params = useParams();
  const blog_slug = params.blog_slug;

  const [blog, setBlog] = useState(null);

  useEffect(() => {
    AxiosClient.get(API_GET_SINGLE_BLOG + blog_slug)
      .then((response) => {
        let responseData = response.data;

        if (responseData.success === true) {
          setBlog(responseData.data);
        }

        console.log(responseData.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <main>
      <Helmet>
        <title>{blog?.meta_title}</title>
        <meta name="keywords" content={blog?.meta_keywords} />
        <meta name="description" content={blog?.meta_description} />
      </Helmet>

      {blog == null ? (
        <BreadCrumb
          title="Loading ..."
          desc="Enrich your knowelge and always stay updated with our blog"
        />
      ) : (
        <BreadCrumb title={blog.title} desc={``} />
      )}

      <section>
        <div className="container">
          <div className="row">
            <div className="col-12">
              {blog == null ? (
                <div className="text-center">
                  <Loader />
                </div>
              ) : (
                <div className="single-blog-wrap">
                  {blog?.image != null && blog?.image != "" && (
                    <NativeLazyImage alt="" src={blog.image} />
                  )}

                  <div className="mt-3">
                    <strong className="fw-500">Published on: </strong>{" "}
                    {blog.authored_date}
                  </div>
                  <div>
                    <strong className="fw-500">By: </strong> {blog.user.name}
                  </div>

                  <div className="blog-content mt-5">
                    <RawHTML rawHTML={blog.description} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
